import React, {useState} from 'react';
import {Template} from "../../../../components/template/template.jsx";
import InputForm from "../../../../components/input/input-form.jsx";
import {Card} from "../../../../components/card/card.jsx";
import Button from "../../../../components/button/button.jsx";
import {useParams} from "react-router";
import {FaPlus} from "react-icons/fa";
import {navigateHook} from "../../../../hooks/use-navigate.js";
import {useQuery} from "@tanstack/react-query";
import neighborhoodService from "../../../../services/web/neighborhood-service.js";
import projectUtils from "../../../../utils/project-utils.js";
import SentryRow from "../../../../components/template/sentry-row.jsx";
import {useGlobalKey} from "../../../../hooks/use-global-key.js";

const NeighborhoodForm = () => {
    const navigate = navigateHook();

    const {id} = useParams()
    const [state, setState] = useState({name: ""})

    const { isLoading, refetch: refetchNeighborhood} = useQuery({
        queryFn: () =>  neighborhoodService.get(id).then((data) => {
            setState(data)
            return []
        }),
        queryKey: ['neighborhoo'],
        enabled: !!id
    });

    const onChange = ({target: {value, id}}) => setState(prev => ({...prev, [id]: value}))

    const save = () => {
        const formData = new FormData();

        const form = {
            name: state.name
        };

        Object.keys(form).forEach(key => {
            formData.append(key, form[key])
        });

        if (!!id) formData.append('_method', 'PUT');


        const response = !!id ? neighborhoodService.edit(id, formData) : neighborhoodService.create(formData);
        response
            .then(({data}) => {
                projectUtils.success(!id);

                if (id) {
                    refetchNeighborhood();
                    return;
                }

                navigateToEdit(data)
            })
            .catch((error) => {
                console.error(error);

                const {message} = error.response.data;

                let errMessage = message ?? "Não foi possível salvar.";
                projectUtils.swalErrorMessage("", errMessage, "Ok");
            })

    }

    const destroy = () => {
        projectUtils.swalMessage(
            "warning",
            "Excluir",
            `Excluir o bairro "${state.name ?? ""}"?`,
            "Sim",
            true,
            "Não",
            ({isConfirmed}) => {
                if (isConfirmed) {
                    neighborhoodService.destroy(id).then(() => {
                        navigateToList()
                        projectUtils.success(true, "Excluído com sucesso");
                    })
                }
            }
        );
    }

    const navigateToList = () => {
        let isBlank = false;
        let urlDev = `/neighborhood`;
        navigate(urlDev, isBlank);
    }

    const newNeighborhood = () => {
        let isBlank = false;
        let urlDev = `/neighborhood/form`;
        navigate(urlDev, isBlank);
    }

    const navigateToEdit = (data) => {
        let isBlank = false;
        let urlDev = `/neighborhood/form/${data.id}`;
        navigate(urlDev, isBlank);
    }

    return (
        <Template isLoading={isLoading}>
            <Template.Header>
                <Template.Title>
                    Bairro
                </Template.Title>
                {
                    id &&
                    <>
                        <Button target={"primary-outline"} onClick={() => newNeighborhood()}>
                            <FaPlus/>
                            Adicionar bairro
                        </Button>
                    </>
                }

            </Template.Header>

            <Template.Body>
                <Card>
                    <Card.Body>
                        <SentryRow>
                            <div className="col-span-12">
                                <InputForm id="name" value={state.name} onChange={onChange}
                                           label="Nome *"/>
                            </div>
                        </SentryRow>
                    </Card.Body>
                </Card>

                <Card className={"mt-2"}>
                    <Card.Body>
                        <div className="w-full flex justify-end">
                            <div className="flex gap-2">
                                {
                                    id &&
                                    <>
                                        <Button target="danger" onClick={destroy} actionFeedbackType='delete'>

                                            Excluir
                                        </Button>
                                    </>
                                }

                                <Button onClick={save} actionFeedbackType='save'>

                                    Salvar
                                </Button>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            </Template.Body>
        </Template>
    );
};

export default NeighborhoodForm;